module.exports = __webpack_public_path__ + "static/media/app-store.fd2b5f26.png";